import reportService from '../services/reportService.js';
import discService from '@/services/discService';
import shopService from '@/services/shopService';
import postQueue from '../services/postQueue';
import { getTotalObjectValues } from '@/services/utils.js';
var ObjectID = require('bson-objectid');
export const report = {
  namespaced: true,
  state: {
    reports: [],
    reportTotals: [],
    filterBy: { date: Date.now(), era: new Date().getDate() > 15 ? 2 : 1 },
    isFetching: false,
  },
  getters: {
    reports(state) {
      return state.reports;
    },
    reportTotals(state) {
      return state.reportTotals;
    },
    filterBy(state) {
      return state.filterBy;
    },
    isFetching(state) {
      return state.isFetching;
    },
  },
  mutations: {
    setReports(state, { reports }) {
      state.reports = reports;
    },
    setReportTotals(state, { totals }) {
      state.reportTotals = totals;
    },
    setFilter(state, { filterBy }) {
      state.filterBy = filterBy;
    },
    setFetch(state, { val }) {
      state.isFetching = val;
    },
    saveReport(state, { savedReport }) {
      const reportIdx = state.reports.findIndex(
        (report) => report._id === savedReport._id,
      );
      if (reportIdx < 0) state.reports.push(savedReport);
      else {
        state.reports = state.reports.map((report) => {
          if (report._id === savedReport._id) return savedReport;
          return report;
        });
        // state.reports.splice(reportIdx, 1, savedReport)
      }
    },
    removeReport(state, { empId }) {
      state.reports = state.reports.filter((report) => report._id !== empId);
    },
    setDisc(state, { disc, key }) {
      const updatedEmpIdx = state.reports.findIndex(
        (emp) => emp._id === disc.empId,
      );
      const emp = state.reports[updatedEmpIdx];
      const updatedEmp = {
        ...emp,
        [key]: { ...emp[key], [disc.name]: disc.amount ? disc : null },
      };
      const totalDisc = Object.keys(updatedEmp.disc).reduce(
        (acc, key) =>
          key === 'bonus'
            ? acc
            : acc + (updatedEmp.disc[key] ? updatedEmp.disc[key].amount : 0),
        0,
      );
      updatedEmp.totalDisc =
        getTotalObjectValues(updatedEmp.shop, 'amount') + totalDisc;
      const bonus = updatedEmp.disc.bonus ? updatedEmp.disc.bonus.amount : 0;
      updatedEmp.total =
        updatedEmp.totalSalaryNomina - updatedEmp.totalDisc + bonus;
      state.reports.splice(updatedEmpIdx, 1, updatedEmp);
    },
  },
  actions: {
    async loadReports(context) {
      context.commit('user/toggleLoader', null, { root: true });
      context.commit({ type: 'setReports', reports: [] });
      const { filterBy } = context.state;
      try {
        const { reports, totals } = await reportService.query(filterBy);
        context.commit({ type: 'setReports', reports });
        if (totals) context.commit({ type: 'setReportTotals', totals });
      } catch (err) {
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async saveReport(context, action) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        const savedReport = await reportService.save(action.editedItem);
        context.commit({ type: 'saveReport', savedReport });
      } catch (err) {
        postQueue.addToQueue(
          { func: reportService.save, params: [action.editedItem] },
          {
            func: context.commit,
            params: [{ type: 'saveReport', savedReport: 'res' }],
          },
        );
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async deleteReport(context, { empId }) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        context.commit({ type: 'removeReport', empId });
        const res = await reportService.remove(empId);
      } catch (err) {
        postQueue.addToQueue(reportService.remove, [empId]);
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async saveDisc(context, { disc }) {
      if (!disc._id && disc.amount) {
        disc._id = ObjectID();
        await discService.add(disc);
      }
      if (disc._id) {
        if (!disc.amount) discService.remove(disc._id);
        else discService.update(disc);
      }
      context.commit({ type: 'setDisc', disc, key: 'disc' });
    },
    async saveShop(context, { shop }) {
      if (!shop._id && shop.amount) {
        shop._id = ObjectID();
        await shopService.add(shop);
      }
      if (shop._id) {
        if (!shop.amount) shopService.remove(shop._id);
        else shopService.update(shop);
      }
      context.commit({ type: 'setDisc', disc: shop, key: 'shop' });
    },
    async downloadReport(context) {
      context.commit({ type: 'setFetch', val: true });
      const res = await reportService.downloadReport(context.state.filterBy);
      context.commit({ type: 'setFetch', val: false });
      let fileName = res.headers['content-disposition'].split('=')[1];
      const type = res.headers['content-type'];
      var reader = new FileReader();
      var blob = new Blob([res.data], { type });
      reader.readAsDataURL(blob);
      reader.onloadend = function (e) {
        var a = document.createElement('a');
        a.href = reader.result;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      };
    },
  },
};
